import { Pipe, PipeTransform } from '@angular/core';

import { FormTemplateInfo } from 'services/application/application.service';

@Pipe({
    name: 'formTemplate'
})
export class FormTemplatePipe implements PipeTransform {
    transform(value: number, formTemplates: FormTemplateInfo[]) {
        if (value == null) { return ''; }
        if (!formTemplates || !formTemplates.length) { return value; }

        const ntype = formTemplates.find(item => item.FormTemplateID === value);

        return (ntype ? ntype.Name : value);
    }
}
